import * as S from './BetaBadge.styled';

const BetaBadge = () => <S.Badge>Beta</S.Badge>;

export default BetaBadge;
